import { render, staticRenderFns } from "./ScreenSelect.vue?vue&type=template&id=4ff963ba&"
import script from "./ScreenSelect.vue?vue&type=script&lang=js&"
export * from "./ScreenSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports